import React from "react";
import Links from "./Links";
import { useGeolocation } from "src/utils/localization/geolocation/GeolocationContext";
import { Geolocation } from "src/utils/localization/geolocation/geolocation";

import {
  ValidatedMainMenuItem,
  pageDescriptionOrOverride,
  pageTitleOrOverride,
  toMenuItemImage
} from "../../utils";
import { isPresent } from "src/utils/checks";
import { matchesAny } from "src/utils/localization/geolocation";

type GenericLinksProps = {
  showItemsMedia?: boolean;
  items: ValidatedMainMenuItem[];
};
const GenericLinks: React.FC<GenericLinksProps> = ({
  items,
  showItemsMedia = false
}) => {
  const geolocation = useGeolocation();

  const links = toLinks(items, showItemsMedia, geolocation);
  return <Links links={links} />;
};

export default GenericLinks;

const toLinks = (
  items: ValidatedMainMenuItem[],
  showItemsMedia: boolean,
  geolocation: Geolocation
) => {
  return items.map(toLink(showItemsMedia, geolocation)).filter(isPresent);
};

export const toLink =
  (showItemsMedia: boolean, geolocation: Geolocation) =>
  (item: ValidatedMainMenuItem) => {
    if (item.__typename === "SanityLocationSpecificMainMenuItem") {
      //location specific
      if (!matchesAny(item.filters, geolocation)) {
        return undefined;
      }
    }

    return {
      _key: item._key,
      href: item.page.fullPath,
      trackingName: item.trackingName,
      label: pageTitleOrOverride(item),
      image: showItemsMedia
        ? toMenuItemImage(item.page.card?.image, item.icon)
        : undefined,
      content: pageDescriptionOrOverride(item)
    };
  };
